import { FetchDocumentSignaturesHookProps } from "../types";
import { useFetchDocumentSignaturesQuery } from "../../../../services/clientdocuments";

export const useFetchDocumentSignatures = (documentId: string) : FetchDocumentSignaturesHookProps => {
    const { data, error, isLoading } = useFetchDocumentSignaturesQuery(documentId)

    return {
        data: data ?? [],
        error,
        isLoading
    };
};